import React from "react";
import { useTranslation } from "react-i18next";

function VisionPrescription({ item }) {
  const { t, i18n } = useTranslation();
  if (!item?.vision_prescription_data) {
    return (
      <div className="text-center py-4 text-gray-500 text-sm">
        {t("No Vision Prescription")}
      </div>
    );
  }

  const renderField = (label, value) => (
    <div className="flex flex-col">
      <span className="text-[11px] font-bold text-gray-500 uppercase tracking-tight">
        {t(label)}
      </span>
      <span className="text-[12px] font-bold text-[#0070C2] truncate">
        {value || "---"}
      </span>
    </div>
  );

  return (
    <div className="space-y-2 mt-2">
      {/* Date Written */}
      <div className="border border-slate-200 rounded-lg bg-white p-2">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {renderField(
            "Date Written",
            item?.vision_prescription_data?.date_written,
          )}
        </div>
      </div>

      {item?.vision_prescription_data?.lens_specifications?.map((el, index) => (
        <div
          key={index}
          className="border border-slate-200 rounded-lg bg-white overflow-hidden"
        >
          <div className="bg-gray-100 px-3 py-1.5 border-b border-slate-200">
            <span className="text-[11px] font-bold text-gray-800 uppercase tracking-tight">
              {t("Lens Specification")} #{index + 1}
            </span>
          </div>

          <div className="p-2 space-y-3">
            {/* Basic Info */}
            <div className="grid grid-cols-2 lg:grid-cols-5 gap-x-4 gap-y-2">
              {renderField("Product", el?.product)}
              {renderField("Color", el?.color)}
              {renderField("Brand", el?.brand)}
            </div>

            {/* Right Eye */}
            <div className="border-t border-slate-100 pt-2">
              <span className="text-[10px] font-extrabold text-amber-600 uppercase mb-1.5 block">
                {t("Right Eye")}
              </span>
              <div className="grid grid-cols-3 lg:grid-cols-9 gap-x-4 gap-y-2">
                {renderField("Sphere", el?.right?.sphere)}
                {renderField("Cylinder", el?.right?.cylinder)}
                {renderField("Axis", el?.right?.axis)}
                {renderField("Add", el?.right?.add)}
                {renderField("Power", el?.right?.power)}
                {renderField("Back Curve", el?.right?.back_curve)}
                {renderField("Diameter", el?.right?.diameter)}
                {renderField("Prism", el?.right?.prism?.amount)}
                {renderField("Duration", el?.right?.duration?.value)}
              </div>
            </div>

            {/* Left Eye */}
            <div className="border-t border-slate-100 pt-2">
              <span className="text-[10px] font-extrabold text-amber-600 uppercase mb-1.5 block">
                {t("Left Eye")}
              </span>
              <div className="grid grid-cols-3 lg:grid-cols-9 gap-x-4 gap-y-2">
                {renderField("Sphere", el?.left?.sphere)}
                {renderField("Cylinder", el?.left?.cylinder)}
                {renderField("Axis", el?.left?.axis)}
                {renderField("Add", el?.left?.add)}
                {renderField("Power", el?.left?.power)}
                {renderField("Back Curve", el?.left?.back_curve)}
                {renderField("Diameter", el?.left?.diameter)}
                {renderField("Prism", el?.left?.prism?.amount)}
                {renderField("Duration", el?.left?.duration?.value)}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default VisionPrescription;
